<template>
  <div class="dateTypeSelector">
    <div class="row p-mergerDateOption" :key="dateKey">
      <template v-if="!noLeftTitle">
        <el-select
          v-if="!isOnlyOne"
          v-model="innerType"
          placeholder="时间类型"
          :style="{ width: typeWidth + 'px' }"
          class="border-right-radius-none border-right-none"
          @change="changeType"
        >
          <el-option
            v-for="item in timeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <div class="leftname" v-if="isOnlyOne" :style="leftNameStyle">
          {{ timeOptions[0].label }}
        </div>
      </template>

      <el-date-picker
        :key="pickerKey"
        ref="datepickerLeft"
        class="timebordernone date-picker-left"
        :class="{
          'no-left-title': noLeftTitle,
        }"
        :clearable="clearable"
        v-model="date[0]"
        :style="{
          width: pickerType == 'date' ? '140px' : '170px',
        }"
        :type="pickerType"
        :format="format"
        :value-format="format"
        :placeholder="placeholder"
        @change="changeDate($event, 0)"
        :editable="clearable"
        :shortcuts="startShortcuts"
        :disabled-date="startDisabledDate"
      >
      </el-date-picker>

      <div class="to">至</div>

      <el-date-picker
        :key="pickerKey + rightKey"
        ref="datepickerright"
        class="timebordernone-right date-picker-right"
        :class="{ 'date-picker-right-join': isPrevNextArrowVisible }"
        :clearable="clearable"
        v-model="date[1]"
        :style="{
          width: pickerType == 'date' ? '140px' : '170px',
        }"
        :type="pickerType"
        :format="format"
        :value-format="format"
        :default-time="defaultEndTime"
        :placeholder="placeholder"
        :editable="clearable"
        @change="changeDate($event, 1)"
        :disabled-date="endDisabledDate"
      >
      </el-date-picker>

      <!--前一天后一天的箭头-->
      <div class="right-button" v-if="isPrevNextArrowVisible">
        <div @click="changePrevNextDay(-1)">
          <el-icon><ArrowLeft /></el-icon>
        </div>
        <div @click="changePrevNextDay(1)">
          <el-icon><ArrowRight /></el-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import timeoption from "@/assets/pc/js/timeoption.js";
import { getToday } from "@/util/date.js";
import moment from "moment";
import func from "@/util/func.js";
import { ArrowLeft, ArrowRight } from "@element-plus/icons-vue";

export default {
  name: "dateTypeSelector",
  components: { ArrowLeft, ArrowRight },
  props: {
    type: {
      //timeOptions的值
      type: String,
      default: "",
    },
    date: {
      //时间日期默认当天，格式为数组 [开始日期, 结束日期]
      type: Array,
      default: () => getToday(),
    },
    timeOptions: {
      //多选的下拉
      type: Array,
      default: [],
    },
    clearable: {
      //时间是否可以清空
      type: Boolean,
      default: false,
    },
    typeWidth: {
      //多选时候左边的宽度
      type: Number,
      default: 150,
    },
    pickerOptions: {
      //原来的时间范围公共选项
      type: Object,
      default: () => timeoption,
    },
    timeRangeDay: {
      //限制时间范围 默认1年
      type: Number,
      default: 366,
    },
    defaultValForSuppCompletion: {
      type: Boolean,
      default: false,
    },
    pickerType: {
      type: String,
      default: "date", // date | datetime
    },
    placeholder: {
      type: String,
      default: "请选择日期",
    },
    selectFutureOnly: {
      // 新增 prop，控制是否只选择未来日期
      type: Boolean,
      default: false,
    },
    futureDaysOffset: {
      // 新增 prop，控制从今天之后的第几天开始可选
      type: Number,
      default: 0,
    },
    //用于外部控制单一标题时的样式
    leftNameStyle: {
      type: Object,
      default: () => ({}),
    },
    noLeftTitle: {
      // 是否不显示左侧标题
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      innerType: this.type, // 内部管理的类型值，避免直接修改 props
      daysTimestamp: "", //时间戳
      dateKey: 0,
      rightKey: 0,
      pickerKey: 0,
      isPrevNextArrowVisible: false, // 前后一天箭头是否显示
      //todo:时间快捷选项
    };
  },
  watch: {
    // 监听外部传入的 type 变化，同步到内部状态
    type(newVal) {
      this.innerType = newVal;
    },
    date: {
      handler() {
        this.updatePrevNextArrowVisible();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    format() {
      return this.pickerType == "date" ? "YYYY-MM-DD" : "YYYY-MM-DD HH:mm";
    },
    endTimeHoursAndMinutes() {
      return this.pickerType == "date" ? "" : " 23:59";
    },
    // 计算属性：默认结束时间（用于 datetime 类型）
    defaultEndTime() {
      if (this.pickerType === "datetime") {
        // Element Plus 的 default-time 需要是 Date 对象
        const endTime = new Date(2000, 1, 1, 23, 59, 59);
        return endTime;
      }
      return undefined;
    },
    isOnlyOne() {
      return this.timeOptions.length === 1 ? true : false;
    },
    // Element Plus 格式的 shortcuts
    startShortcuts() {
      if (this.selectFutureOnly) {
        return [];
      }
      return this.getStartShortcuts();
    },
    // Element Plus 格式的 disabled-date 函数
    startDisabledDate() {
      return (time) => {
        if (this.selectFutureOnly) {
          const earliestSelectableDateBasedOnOffset = moment()
            .add(this.futureDaysOffset, "days")
            .startOf("day");
          if (moment(time).isBefore(earliestSelectableDateBasedOnOffset)) {
            return true;
          }
        }
        return false;
      };
    },
    // Element Plus 格式的结束日期 disabled-date 函数
    endDisabledDate() {
      return (time) => {
        if (this.selectFutureOnly) {
          const earliestSelectableDateBasedOnOffset = moment()
            .add(this.futureDaysOffset, "days")
            .startOf("day");
          if (moment(time).isBefore(earliestSelectableDateBasedOnOffset)) {
            return true;
          }
        }

        let startDateStr = this.date[0]; // 获取开始日期
        if (startDateStr) {
          const startDate = moment(startDateStr).startOf("day");
          // 结束日期不能早于开始日期
          if (moment(time).isBefore(startDate)) {
            return true;
          }
          // 结束日期必须在开始日期的 timeRangeDay 范围内
          const latestEndDateFromRange = moment(startDate)
            .add(this.timeRangeDay - 1, "days")
            .startOf("day");
          if (moment(time).isAfter(latestEndDateFromRange)) {
            return true;
          }
        }
        return false;
      };
    },
    // startPickeoption() {
    //   const that = this;
    //   return {
    // disabledDate: (time) => {
    //   const endDate = this.date[1]; // 获取结束日期

    //   if (endDate) {
    //     // 限制选择的起始日期不能超过一年
    //     return (
    //       time.getTime() <
    //         Number(moment(endDate).format("x")) - this.daysTimestamp ||
    //       time.getTime() > Number(moment(endDate).format("x"))
    //     );
    //   }
    //   return false; // 一年的毫秒数：31536000000
    // },
    //     shortcuts:[
    // {
    //   text: "昨天",
    //   onClick(picker) {
    //     const start = new Date();
    //     start.setTime(start.getTime() - 3600 * 1000 * 24);
    //     that.date[1] = moment(start).format("YYYY-MM-DD");
    //     picker.$emit("pick", start);
    //   },
    // },
    // {
    //   text: "今天",
    //   onClick(picker) {
    //     const start = new Date();
    //     that.date[1] = moment(start).format("YYYY-MM-DD");
    //     picker.$emit("pick", start);
    //   },
    // },
    // {
    //   text: "上周",
    //   onClick(picker) {
    //     const end = new Date();
    //     const start = new Date();
    //     const monday = start.getDay() + 6;
    //     const sunday = start.getDay();
    //     start.setTime(start.getTime() - 3600 * 1000 * 24 * monday);
    //     end.setTime(end.getTime() - 3600 * 1000 * 24 * sunday);
    //     that.date[1] = moment(end).format("YYYY-MM-DD");
    //     picker.$emit("pick", start);
    //   },
    // },
    // {
    //   text: "本周",
    //   onClick(picker) {
    //     const end = new Date();
    //     const start = new Date();
    //     const monday = start.getDay() - 1;
    //     const sunday = 7 - start.getDay();
    //     start.setTime(start.getTime() - 3600 * 1000 * 24 * monday);
    //     end.setTime(end.getTime() + 3600 * 1000 * 24 * sunday);
    //     that.date[1] = moment(end).format("YYYY-MM-DD");
    //     picker.$emit("pick", start);
    //   },
    // },
    // {
    //   text: "上月",
    //   onClick(picker) {
    //     const end = new Date();
    //     const start = new Date();
    //     const endday = end.getDate();
    //     start.setDate(1);
    //     start.setMonth(start.getMonth() - 1);
    //     end.setTime(end.getTime() - 3600 * 1000 * 24 * endday);
    //     that.date[1] = moment(end).format("YYYY-MM-DD");
    //     picker.$emit("pick", start);
    //   },
    // },
    // {
    //   text: "本月",
    //   onClick(picker) {
    //     const end = new Date();
    //     const start = new Date();
    //     start.setDate(1);
    //     end.setDate(1);
    //     end.setMonth(end.getMonth() + 1);
    //     end.setTime(end.getTime() - 3600 * 1000 * 24);
    //     that.date[1] = moment(end).format("YYYY-MM-DD");
    //     picker.$emit("pick", start);
    //   },
    // },
    // {
    //   text: "去年",
    //   onClick(picker) {
    //     const end = new Date();
    //     const start = new Date();
    //     start.setMonth(0);
    //     start.setDate(1);
    //     start.setFullYear(start.getFullYear() - 1);
    //     end.setMonth(0);
    //     end.setDate(1);
    //     end.setTime(end.getTime() - 3600 * 1000 * 24);
    //     that.date[1] = moment(end).format("YYYY-MM-DD");
    //     picker.$emit("pick", start);
    //   },
    // },
    // {
    //   text: "今年",
    //   onClick(picker) {
    //     const end = new Date();
    //     const start = new Date();
    //     start.setMonth(0);
    //     start.setDate(1);
    //     end.setMonth(0);
    //     end.setDate(1);
    //     end.setFullYear(end.getFullYear() + 1);
    //     end.setTime(end.getTime() - 3600 * 1000 * 24);
    //     that.date[1] = moment(end).format("YYYY-MM-DD");
    //     picker.$emit("pick", start);
    //   },
    // },
    // {
    //   text: "最近一周",
    //   onClick(picker) {
    //     const end = new Date();
    //     const start = new Date();
    //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    //     that.date[1] = moment(end).format("YYYY-MM-DD");
    //     picker.$emit("pick", start);
    //     that.pickerKey++;
    //   },
    // },
    // {
    //   text: "最近一个月",
    //   onClick(picker) {
    //     const end = new Date();
    //     const start = new Date();
    //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    //     that.date[1] = moment(end).format("YYYY-MM-DD");
    //     picker.$emit("pick", start);

    //   },
    // },
    // {
    //   text: "最近三个月",
    //   onClick(picker) {
    //     const end = new Date();
    //     const start = new Date();
    //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
    //     that.date[1] = moment(end).format("YYYY-MM-DD");
    //     picker.$emit("pick", start);

    //   },
    // },
    //     ],
    //   };
    // },
  },
  components: {},
  created() {
    // 确保初始化时同步外部 type 值，如果没有则使用第一个选项
    if (!this.innerType && this.timeOptions.length > 0) {
      this.innerType = this.timeOptions[0].value;
    }
  },
  mounted() {
    let that = this;
    //跟据天数算出时间戳
    that.daysTimestamp = that.getTimestampFromDays(that.timeRangeDay);
    this.updatePrevNextArrowVisible();
  },
  methods: {
    /**
     * 更新前后一天箭头显示状态
     * 开始和结束日期同一天或相差 1 天时显示
     */
    updatePrevNextArrowVisible() {
      if (!this.date || !this.date[0] || !this.date[1]) {
        this.isPrevNextArrowVisible = false;
        return;
      }
      const startDateMoment = moment(this.date[0]).startOf("day");
      const endDateMoment = moment(this.date[1]).startOf("day");
      if (!startDateMoment.isValid() || !endDateMoment.isValid()) {
        this.isPrevNextArrowVisible = false;
        return;
      }
      const diffDayCount = endDateMoment.diff(startDateMoment, "days");
      this.isPrevNextArrowVisible = diffDayCount === 0 || diffDayCount === 1;
    },
    /**
     * 获取 Element Plus 格式的开始日期快捷选项
     * @returns {Array} shortcuts 数组
     */
    getStartShortcuts() {
      let that = this;
      let shortcutsArr = [];

      shortcutsArr.push({
        text: "昨天",
        value: () => {
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24);
          start.setHours(0, 0, 0, 0);
          // 同时更新结束日期
          that.date[1] =
            moment(start).format("YYYY-MM-DD") + that.endTimeHoursAndMinutes;
          that.rightKey++;
          return start;
        },
      });

      shortcutsArr.push({
        text: "今天",
        value: () => {
          const start = new Date();
          start.setHours(0, 0, 0, 0);
          // 同时更新结束日期
          that.date[1] =
            moment(start).format("YYYY-MM-DD") + that.endTimeHoursAndMinutes;
          that.rightKey++;
          return start;
        },
      });

      shortcutsArr.push({
        text: "上周",
        value: () => {
          const end = new Date();
          const start = new Date();
          const monday = start.getDay() + 6;
          const sunday = start.getDay();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * monday);
          start.setHours(0, 0, 0, 0);
          end.setTime(end.getTime() - 3600 * 1000 * 24 * sunday);
          // 同时更新结束日期
          that.date[1] =
            moment(end).format("YYYY-MM-DD") + that.endTimeHoursAndMinutes;
          that.rightKey++;
          return start;
        },
      });

      shortcutsArr.push({
        text: "本周",
        value: () => {
          const end = new Date();
          const start = new Date();
          const monday = start.getDay() - 1;
          const sunday = 7 - start.getDay();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * monday);
          start.setHours(0, 0, 0, 0);
          end.setTime(end.getTime() + 3600 * 1000 * 24 * sunday);
          // 同时更新结束日期
          that.date[1] =
            moment(end).format("YYYY-MM-DD") + that.endTimeHoursAndMinutes;
          that.rightKey++;
          return start;
        },
      });

      shortcutsArr.push({
        text: "上月",
        value: () => {
          const end = new Date();
          const start = new Date();
          const endday = end.getDate();
          start.setDate(1);
          start.setMonth(start.getMonth() - 1);
          start.setHours(0, 0, 0, 0);
          end.setTime(end.getTime() - 3600 * 1000 * 24 * endday);
          // 同时更新结束日期
          that.date[1] =
            moment(end).format("YYYY-MM-DD") + that.endTimeHoursAndMinutes;
          that.rightKey++;
          return start;
        },
      });

      shortcutsArr.push({
        text: "本月",
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setDate(1);
          start.setHours(0, 0, 0, 0);
          end.setDate(1);
          end.setMonth(end.getMonth() + 1);
          end.setTime(end.getTime() - 3600 * 1000 * 24);
          // 同时更新结束日期
          that.date[1] =
            moment(end).format("YYYY-MM-DD") + that.endTimeHoursAndMinutes;
          that.rightKey++;
          return start;
        },
      });

      if (that.timeRangeDay >= 365) {
        shortcutsArr.push({
          text: "去年",
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setMonth(0);
            start.setDate(1);
            start.setFullYear(start.getFullYear() - 1);
            start.setHours(0, 0, 0, 0);
            end.setMonth(0);
            end.setDate(1);
            end.setTime(end.getTime() - 3600 * 1000 * 24);
            // 同时更新结束日期
            that.date[1] =
              moment(end).format("YYYY-MM-DD") + that.endTimeHoursAndMinutes;
            that.rightKey++;
            return start;
          },
        });

        shortcutsArr.push({
          text: "今年",
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setMonth(0);
            start.setDate(1);
            start.setHours(0, 0, 0, 0);
            end.setMonth(0);
            end.setDate(1);
            end.setFullYear(end.getFullYear() + 1);
            end.setTime(end.getTime() - 3600 * 1000 * 24);
            // 同时更新结束日期
            that.date[1] =
              moment(end).format("YYYY-MM-DD") + that.endTimeHoursAndMinutes;
            that.rightKey++;
            return start;
          },
        });
      }

      shortcutsArr.push({
        text: "最近一周",
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          start.setHours(0, 0, 0, 0);
          // 同时更新结束日期
          that.date[1] =
            moment(end).format("YYYY-MM-DD") + that.endTimeHoursAndMinutes;
          that.rightKey++;
          return start;
        },
      });

      shortcutsArr.push({
        text: "最近一个月",
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          start.setHours(0, 0, 0, 0);
          // 同时更新结束日期
          that.date[1] =
            moment(end).format("YYYY-MM-DD") + that.endTimeHoursAndMinutes;
          that.rightKey++;
          return start;
        },
      });

      if (that.timeRangeDay >= 60) {
        shortcutsArr.push({
          text: "最近三个月",
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            start.setHours(0, 0, 0, 0);
            // 同时更新结束日期
            that.date[1] =
              moment(end).format("YYYY-MM-DD") + that.endTimeHoursAndMinutes;
            that.rightKey++;
            return start;
          },
        });
      }

      return shortcutsArr;
    },
    getTimestampFromDays(days) {
      // 计算给定天数后的时间戳
      const millisecondsInADay = 24 * 60 * 60 * 1000;
      return days * millisecondsInADay;
    },
    /**
     * 处理时间类型变化
     * @param {String} val - 选中的时间类型值
     */
    changeType(val) {
      this.innerType = val; // 更新内部状态
      this.$emit("changeType", val); // 触发父组件事件
    },
    changeDate(val, position) {
      let that = this;

      //最大的时间戳
      const MaxDaysInMillis = Number(that.timeRangeDay) * 24 * 60 * 60 * 1000;

      //计算 that.timeRangeDay 的时间戳

      if (position == 0) {
        // 处理开始日期变化
        let startTime = Number(moment(val).format("x"));

        //如果开启了这个在第一个日期输入的时候判断第二个日期没有则赋值给第二个日期
        if (this.defaultValForSuppCompletion && func.isEmpty(this.date[1])) {
          let newDate =
            moment(startTime).format("YYYY-MM-DD") +
            that.endTimeHoursAndMinutes;
          this.date[1] = newDate;
          this.dateKey++;
        } else if (!func.isEmpty(this.date[1])) {
          // 如果结束日期已存在，根据时间范围调整结束日期
          let endTime = Number(moment(this.date[1]).format("x"));
          const timeDifferenceInMillis = endTime - startTime;
          const MaxDaysInMillis =
            Number(that.timeRangeDay) * 24 * 60 * 60 * 1000;

          if (timeDifferenceInMillis < 0) {
            // 如果选择的开始时间晚于结束时间，将结束时间设置为相同的时间
            let newDate =
              moment(startTime).format("YYYY-MM-DD") +
              that.endTimeHoursAndMinutes;
            this.date[1] = newDate;
            this.dateKey++;
          } else if (timeDifferenceInMillis > MaxDaysInMillis) {
            // 如果选择的时间早于时间范围 timeRangeDay，则修改结束时间为开始时间 + timeRangeDay
            let newDate =
              moment(startTime)
                .add(that.timeRangeDay - 1, "days")
                .format("YYYY-MM-DD") + that.endTimeHoursAndMinutes;
            this.date[1] = newDate;
            this.dateKey++;
          }
          // 如果在时间范围中间则不修改结束时间
        }

        this.updatePrevNextArrowVisible();
        this.$emit("changeDate", [val, this.date[1]]);
      } else {
        this.updatePrevNextArrowVisible();
        this.$emit("changeDate", [this.date[0], val]);
      }
    },
    /**
     * 开始和结束日期同步前后平移一天
     * @param {Number} shiftDayCount - 日期平移值，前一天为 -1，后一天为 1
     */
    changePrevNextDay(shiftDayCount) {
      if (!this.date || !this.date[0] || !this.date[1]) {
        return;
      }
      const startDateMoment = moment(this.date[0]);
      const endDateMoment = moment(this.date[1]);
      if (!startDateMoment.isValid() || !endDateMoment.isValid()) {
        return;
      }
      const nextStartDate = startDateMoment
        .clone()
        .add(shiftDayCount, "days")
        .format(this.format);
      const nextEndDate = endDateMoment
        .clone()
        .add(shiftDayCount, "days")
        .format(this.format);

      this.date[0] = nextStartDate;
      this.date[1] = nextEndDate;
      this.updatePrevNextArrowVisible();
      this.$emit("changeDate", [nextStartDate, nextEndDate]);
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.dateTypeSelector {
  color: #666;

  .leftname {
    line-height: 30px;
    border: 1px solid #dcdfe6;
    font-size: 14px;
    padding: 0 16px 0 12px;
    border-radius: 4px 0 0 4px;
    border-right: none;
    min-width:90px;
  }
  .to {
    line-height: 28px;
    padding: 0 6px;
    font-size: 13px;
    border-top: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
  }
  .right-button {
    background-color: #f5f5f5;
    height: 32px;
    line-height: 32px;
    width: 60px;
    border: 1px solid #e6e6e6;
    box-sizing: border-box;
    border-left: 0;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    display: flex;
    align-items: center;
  }
  .right-button > div {
    width: 50%;
    text-align: center;
    height: 32px;
    line-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .right-button > div:hover {
    background-color: #28b8c3;
    color: #fff;
  }
  .right-button > div:last-child {
    border-left: 1px solid #e6e6e6;
    box-sizing: border-box;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}

.el-date-picker {
  border: none;
}

// 去除 el-select 右边框
.border-right-none {
  :deep(.el-input__wrapper) {
    border-right: none;
  }
}

// 去除 el-select 右边圆角
.border-right-radius-none {
  :deep(.el-select__wrapper) {
    box-shadow: none !important;
    border: 1px solid #e5e5e5;
    border-right: none;
    border-radius: 4px 0 0 4px;
  }
}

// 左侧日期选择器：去除左右边框，去除左右圆角，保留上下边框
.date-picker-left {
  :deep(.el-input__wrapper) {
    box-shadow: none !important;
    border: 1px solid #e5e5e5;
    border-left: none;
    border-right: none;
    border-radius: 0 !important;
  }
}

// 右侧日期选择器：去除左边框，去除左边圆角，添加其他边框
.date-picker-right {
  :deep(.el-input__wrapper) {
    box-shadow: none !important;
    border: 1px solid #e5e5e5;
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}



.border-left-radius-none {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  :deep(.el-input__wrapper) {
    border-radius: none !important;
  }
}

.border-left-none {
  border-left: none;

  :deep(.el-input__wrapper) {
    border-left: none;
  }
}
</style>
